import PreviewAlert from 'components/PreviewAlert';
import Header from 'components/blocks/Header';
import Footer from 'components/blocks/Footer';
import { DrupalMenuLinkContent, DrupalNode } from 'next-drupal';
import Metatags from 'components/Metatags';
import { CartProvider } from 'lib/cart-context';

export interface LayoutCommerceProps {
  entity: DrupalNode;
  menus: {
    main: DrupalMenuLinkContent[];
    footer: DrupalMenuLinkContent[];
    stickyShop: DrupalMenuLinkContent[];
  };
  children?: React.ReactNode;
}

export default function LayoutCommerce({ entity, menus, children }) {
  // TT-713: siehe Layout.tsx — im R1-Layout gilt überall das blaue Base-Theme.
  // Zurück: const theme = entity?.field_theme ?? '';
  const theme = '';
  return (
    <>
      <Metatags entity={entity} />
      <div className={`${theme} text-secondary`}>
        <PreviewAlert />
        <Header menus={menus} />
        <main>{children}</main>
        <Footer menu={menus.footer} />
      </div>
    </>
  );
}
